package dev.danko.roblox_craft_ai.uikit.config

import kotlinx.browser.localStorage
import kotlinx.browser.window

object BackendEndpoint {
    private const val OVERRIDE_STORAGE_KEY = "robloxCraft.apiBase"
    private const val KOBWEB_DEV_PORT = "5712"
    private const val DEV_BACKEND_PORT = 9095

    val httpBase: String by lazy { resolveHttpBase() }

    val wsBase: String by lazy {
        when {
            httpBase.startsWith("https://") -> "wss://" + httpBase.removePrefix("https://")
            httpBase.startsWith("http://") -> "ws://" + httpBase.removePrefix("http://")
            else -> httpBase
        }
    }

    fun http(path: String): String = httpBase + path

    fun ws(path: String): String = wsBase + path

    fun resolveAssetUrl(url: String): String = if (url.startsWith("/")) http(url) else url

    private fun resolveHttpBase(): String {
        val override = runCatching { localStorage.getItem(OVERRIDE_STORAGE_KEY) }.getOrNull()?.trim()?.trimEnd('/')
        if (!override.isNullOrBlank()) return override
        val location = window.location
        return if (location.port == KOBWEB_DEV_PORT) {
            "${location.protocol}//${location.hostname}:$DEV_BACKEND_PORT"
        } else {
            location.origin
        }
    }
}

/**
 * In development the site (port 5712) and the backend (port 9095) are different origins, so the browser would not send
 * the HttpOnly sign-in cookie. This wraps window.fetch once to use `credentials: include` for backend requests only.
 * In production both are served from one origin and nothing changes.
 */
object BackendCredentials {
    private var installed = false

    fun install() {
        if (installed) return
        installed = true
        val base = BackendEndpoint.httpBase
        if (base == window.location.origin) return
        val patch: dynamic = js(
            """(function (base) {
                var original = window.fetch.bind(window);
                window.fetch = function (input, init) {
                    var url = typeof input === 'string' ? input : (input && input.url) || '';
                    if (url.indexOf(base) === 0) {
                        init = Object.assign({}, init || {});
                        if (!init.credentials) init.credentials = 'include';
                    }
                    return original(input, init);
                };
            })"""
        )
        patch(base)
    }
}
